import type { SpendChartPoint } from 'src/queries/reporting/reporting.models'

export const isOpaqueReportingKey = (label: string | undefined): boolean => {
  if (label === undefined) return true
  const value = label.trim()
  if (value === '') return true

  return (
    /^(dept|department|team|user|person|card|cardholder|vc|vcn|usr)_[a-z0-9_-]+$/i.test(
      value,
    ) ||
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      value,
    )
  )
}

export const firstPresentMetadataValue = (
  point: SpendChartPoint,
  keys: string[],
): string | undefined => {
  for (const key of keys) {
    const value = point.metadata[key]
    if (value !== undefined && value !== null && value.trim() !== '') {
      return value
    }
  }

  return undefined
}

export const getPointDisplayLabel = (
  point: SpendChartPoint,
  fallbackLabel: string,
  metadataKeys: string[] = [],
): string => {
  const metadataLabel = firstPresentMetadataValue(point, metadataKeys)
  if (metadataLabel !== undefined && !isOpaqueReportingKey(metadataLabel)) {
    return metadataLabel
  }

  const label = point.seriesLabel ?? point.label
  if (!isOpaqueReportingKey(label)) return label

  return fallbackLabel
}
